export default function Edge({ link, steps }) {

  const from = steps.find(s => s.id === link.fromStepId);
  const to   = steps.find(s => s.id === link.toStepId);

  if (!from || !to) return null;

  const x1 = from.x + 80;
  const y1 = from.y + 20;
  const x2 = to.x + 80;
  const y2 = to.y + 20;

  // horizontal first, then vertical (elbow)
 
const midX1 = x1 + (x2 - x1) * 0.1;
const midX2 = x1 + (x2 - x1) * 0.2;
const midX3 = x1 + (x2 - x1) * 0.3;
const midX4 = x1 + (x2 - x1) * 0.4;
const midX5 = x1 + (x2 - x1) * 0.5;
const midX6 = x1 + (x2 - x1) * 0.6;
const midX7 = x1 + (x2 - x1) * 0.7;
const midX8 = x1 + (x2 - x1) * 0.8;
const midX9 = x1 + (x2 - x1) * 0.9;
const midX10 = x1 + (x2 - x1) * 0.10;
const midX11 = x1 + (x2 - x1) * 0.11;
const midX12 = x1 + (x2 - x1) * 0.12;
const midX13 = x1 + (x2 - x1) * 0.13;
const midX14 = x1 + (x2 - x1) * 0.14;
const midX15 = x1 + (x2 - x1) * 0.15;
const midX16 = x1 + (x2 - x1) * 0.16;
const midX17 = x1 + (x2 - x1) * 0.17;
const midX18 = x1 + (x2 - x1) * 0.18;
const midX19 = x1 + (x2 - x1) * 0.19;
const midX20 = x1 + (x2 - x1) * 0.20;
const midX21 = x1 + (x2 - x1) * 0.21;
const midX22 = x1 + (x2 - x1) * 0.22;
const midX23 = x1 + (x2 - x1) * 0.23;
const midX24 = x1 + (x2 - x1) * 0.24;
const midX25 = x1 + (x2 - x1) * 0.25;
const midX26 = x1 + (x2 - x1) * 0.26;
const midX27 = x1 + (x2 - x1) * 0.27;
const midX28 = x1 + (x2 - x1) * 0.28;
const midX29 = x1 + (x2 - x1) * 0.29;
const midX30 = x1 + (x2 - x1) * 0.30;

const midX31 = x1 + (x2 - x1) * 0.31;
const midX32 = x1 + (x2 - x1) * 0.32;
const midX33 = x1 + (x2 - x1) * 0.33;
const midX34 = x1 + (x2 - x1) * 0.34;
const midX35 = x1 + (x2 - x1) * 0.35;
const midX36 = x1 + (x2 - x1) * 0.36;
const midX37 = x1 + (x2 - x1) * 0.37;
const midX38 = x1 + (x2 - x1) * 0.38;
const midX39 = x1 + (x2 - x1) * 0.39;
const midX40 = x1 + (x2 - x1) * 0.40;

  const d = `
    M ${x1} ${y1}
    L ${midX1} ${y2}
    L ${midX2} ${y2}
    L ${midX3} ${y2}
    L ${midX4} ${y2}
    L ${midX5} ${y2}
    L ${midX6} ${y2}
    L ${midX7} ${y2}
    L ${midX8} ${y2}
    L ${midX9} ${y2}
    L ${midX10} ${y2}
    
    L ${midX11} ${y2}
    L ${midX12} ${y2}
    L ${midX13} ${y2}
    L ${midX14} ${y2}
    L ${midX15} ${y2}
    L ${midX16} ${y2}
    L ${midX17} ${y2}
    L ${midX18} ${y2}
    L ${midX19} ${y2}
    
    L ${midX21} ${y2}
    L ${midX22} ${y2}
    L ${midX23} ${y2}
    L ${midX24} ${y2}
    L ${midX25} ${y2}
    L ${midX26} ${y2}
    L ${midX27} ${y2}
    L ${midX28} ${y2}
    L ${midX29} ${y2}
    L ${midX30} ${y2} 

    
    L ${midX31} ${y2}
    L ${midX32} ${y2}
    L ${midX33} ${y2}
    L ${midX34} ${y2}
    L ${midX35} ${y2}
    L ${midX36} ${y2}
    L ${midX37} ${y2}
    L ${midX38} ${y2}
    L ${midX39} ${y2}
    L ${midX40} ${y2} 
    
    L ${x2} ${y2}
  `;

  return (
    <path
      d={d}
      fill="none"
      stroke={link.actionType === "DELAY" ? "orange" : "green"}
      strokeWidth={2}
      markerEnd="url(#link-arrow)"
    />
  );
}
